export default __webpack_public_path__ + "static/media/923.4815edb6.png";